<template>
 <div class="ui centered grid">
    <div class="four wide column"></div>
    <div class="eight wide column">
        <h3 class="ui header"> What is “Art for Display: The painting collection of Emperor Rudolf II within the context of collecting practices circa 1600” project?</h3>
        <p>
        The database was launched as part of a broader research project “Art for display: The Painting Collection of Emperor Rudolf II within the Context of Collecting Practices circa 1600”, established at the Institute of Art History of the Czech Academy of Sciences (supported by The Czech Science Foundation in 2020–2022). 
        </p>
        <p>
        The painting collection of Emperor Rudolf II in Prague, scattered during the Thirty Years’ War, was one of the foremost ensembles of its kind in Europe. The inventories, period testimonies and other sources, and last but not least identified works provide an idea of its scope. Heuristic research and the creation of a specialized database allows an analysis of the collection with a regard to pictorial genres, painting “schools”, taste of the collector and also to its spatial arrangement and administration. The collection has been studied in the context of the collecting activities of the Habsburgs (Madrid, Brussels), the princely courts in Italy (esp. Florence, Mantua) and Germany (Dresden, Munich), as well as with regard to the transformation of painting status in a “gallery exhibit” and to the simultaneous pictorial innovations ca. 1600 (esp. in Rome). Attention is also be paid to Rudolf’s gallery as a specific type of building, taking into account its function in Prague Castle’s residential complex. 
        </p>
        <p>
        The main output of the research will be a monograph in English, in which the significance of Rudolf II’s painting collection will be evaluated, especially in the context of period collecting practice. Partial results will be published in the form of scholarly articles.
        </p>

        <h4 class="ui header">Project team:</h4>
        <div class="ui list">
            <div class="item">
                <div class="content">
                   <a class="header" href="https://www.udu.cas.cz/en/lide/phdr-stepan-vacha-ph-d" target="_blank">Štěpán Vácha - Project Lead</a>
                </div>
                <div class="description">Conceptual direction and methodological grounding, project coordination</div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.linkedin.com/in/guido-carrai-87786963/?locale=en_US" target="_blank">Guido Carrai - Research associate</a>
                </div>
            </div>
            <div class="item">
                <div class="content">
                     <a class="header" href="https://www.udu.cas.cz/en/lide/mgr-sylva-dobalova-ph-d" target="_blank">Sylva Dobalová - Research associate</a>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header">Eliška Fučíková - Research associate</a>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.udu.cas.cz/en/lide/mgr-et-mgr-marketa-jezkova-ph-d" target="_blank">Markéta Ježková - Research associate</a>
                </div>
            </div>
            <div class="item">
                <div class="content">
                    <a class="header" href="https://www.udu.cas.cz/en/lide/prof-phdr-lubomir-konecny" target="_blank">Lubomír Konečný - Research associate</a>
                </div>
            </div>
            <div class="item">
                <div class="content">
                   <a class="header" href="https://www.linkedin.com/in/petr-uli%C4%8Dn%C3%BD-44239a1/" target="_blank">Petr Uličný - Research associate</a>
                </div>
            </div>
        </div>
    </div>
    <div class="four wide column"></div>
</div>


</template>

<script>
   // import TheCarousel from '../components/TheCarousel.vue'
    export default {
        name: 'about',
        data() {
            return {
            }
        },
        mount(){
            
        },
        components: {
          //  TheCarousel
        },
    }
</script>

<style scoped>
    P{
         text-align: justify;
    }
</style>



// WEBPACK FOOTER //
// src/router/aboutproject.vue